import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const TESTID = 'icon-checkmarkcirclefilled';
export const CheckmarkCircleFilledIcon = ({ fill = 'gcBlue', size = 'small' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" className={fillStyles} />
            <path
                d="M7.5 12l3.5 3.5l5.5-6"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </svg>
    );
};
CheckmarkCircleFilledIcon.TEST_ID = TESTID;
